/* eslint-disable jira/filename-case */

import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line jira/wrm/no-load-bridge
import { loadBridge } from '@jira/platform__bridge/src';
import {
	sendStartMarkForLegacyIssueCreate,
	sendEndMarkForLegacyIssueCreate,
} from './sendEndMarkForLegacyIssueCreate.tsx';
import type { TriggerSource } from './types.tsx';

const onCreateClick = ({
	timeout,
	tentatives,

	// isInitialLoad tracks the initial render of global issue create dialog through this entry point (presently called from navigation create button and keyboard shortcut)
	isInitialLoad,

	triggerSource,
	showModern,
}: {
	timeout?: number;
	tentatives?: number;
	isInitialLoad?: boolean;
	triggerSource?: TriggerSource;
	showModern?: boolean;
} = {}): Promise<void> => {
	sendStartMarkForLegacyIssueCreate({ isInitialLoad, triggerSource });

	// eslint-disable-next-line jira/wrm/no-load-bridge
	return loadBridge({
		name: 'quick-edit/init/create-dialogs',
		wrmKeys: [
			'wrc!com.atlassian.jira.jira-quick-edit-plugin:quick-create-issue-bootstrap',
			'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
			'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',
		],
		timeout,
		tentatives,
	}).then((api) => {
		if (fg('render_modern_global_issue_create_modal_experience')) {
			if (showModern === true) {
				// @ts-expect-error - TS2571 - Object is of type 'unknown'.
				api?.hideLoadingIndicator(false);
			} else {
				// @ts-expect-error - TS2571 - Object is of type 'unknown'.
				api?.showCreateDialog({ showModern });
			}
		} else {
			// @ts-expect-error - TS2571 - Object is of type 'unknown'.
			api?.showCreateDialog({});
		}

		sendEndMarkForLegacyIssueCreate({ isInitialLoad });
	});
};

export default onCreateClick;
